import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Katrajtomumbaicab() {



const cardData = {
  keyword: " Katraj to Mumbai Cab Service ",

headingDescription: "Velocity Cab provides reliable and comfortable Katraj to Mumbai cab services, ensuring a smooth and hassle-free journey for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Katraj to Mumbai convenient and stress-free. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Katraj to Mumbai cab travel.",

topPlaces: [
 
  {
    title: "Powai Lake",
    description: "Powai Lake offers a peaceful escape from Mumbai's busy streets with scenic waterfront views, boating opportunities, and nearby restaurants. Travelers choosing an Innova Crysta on rent in Pune can comfortably visit this picturesque destination for a relaxing outing with family and friends. The surrounding greenery and modern skyline create a perfect setting for photography and leisure."
  },
  {
    title: "Haji Ali Dargah",
    description: "Haji Ali Dargah is one of Mumbai's most famous religious landmarks, situated on a small islet in the Arabian Sea. Visitors hiring an Innova Crysta on rent in Pune can enjoy a convenient drive to this spiritual destination and admire its beautiful Indo-Islamic architecture, peaceful atmosphere, and scenic sea views."
  },
  {
    title: "Juhu Beach",
    description: "Juhu Beach is among Mumbai's most visited beaches, attracting visitors with its lively atmosphere, street food, and spectacular sunsets. Booking an Innova Crysta on rent in Pune allows travelers to enjoy a comfortable road journey before spending quality time by the sea with family and friends."
  },
  {
    title: "Global Vipassana Pagoda",
    description: "Global Vipassana Pagoda is an architectural marvel and meditation center located near Gorai. Travelers renting an Innova Crysta in Pune can comfortably reach this peaceful attraction to admire its magnificent golden dome, explore the meditation halls, and experience a calm and spiritual environment."
  },
   {
    title: "Bandra Bandstand",
    description: "Bandra Bandstand is one of Mumbai's most popular seaside promenades, offering breathtaking views of the Arabian Sea and the iconic Bandra-Worli Sea Link. Travelers booking an Innova Crysta on rent in Pune can enjoy a comfortable road trip before relaxing along the waterfront, exploring nearby cafés, and visiting famous celebrity residences. It is an excellent destination for evening walks and photography."
  },
  {
    title: "Gateway of India",
    description: "Gateway of India is Mumbai's most recognizable monument and a must-visit destination for travelers. Renting an Innova Crysta in Pune makes the journey smooth and comfortable for families and groups planning a Mumbai sightseeing tour. Visitors can admire the historic architecture, enjoy ferry rides to Elephanta Island, and capture memorable photographs overlooking the Arabian Sea."
  },
  {
    title: "Colaba Causeway",
    description: "Colaba Causeway is a vibrant shopping destination filled with fashion boutiques, handicraft stalls, cafés, and restaurants. Visitors booking an Innova Crysta on rent in Pune can conveniently explore this bustling market while enjoying shopping, local cuisine, and the colonial charm of South Mumbai."
  },
  {
    title: "Elephanta Caves",
    description: "Elephanta Caves are a UNESCO World Heritage Site renowned for their ancient rock-cut temples and magnificent sculptures of Lord Shiva. Travelers choosing an Innova Crysta on rent in Pune can comfortably travel to Mumbai before taking a ferry to Elephanta Island for an unforgettable historical experience."
  },
  {
    title: "Gilbert Hill",
    description: "Gilbert Hill is a rare volcanic rock formation that dates back millions of years and stands as one of Mumbai's hidden attractions. Renting an Innova Crysta in Pune provides a comfortable journey for travelers looking to discover unique geological landmarks and enjoy panoramic city views from the hilltop."
  },
  {
    title: "Marine Drive",
    description: "Marine Drive, popularly known as the Queen's Necklace, is one of Mumbai's most iconic waterfront destinations. Travelers hiring an Innova Crysta on rent in Pune can relax along the scenic promenade, enjoy breathtaking sunset views, sample local street food, and experience the vibrant charm of Mumbai's coastline."
  }
],



services: [
{
name: "Katraj to Mumbai Airport Cab Fare",
description: "Katraj to Mumbai Airport cab fare service provides transparent pricing for passengers traveling from Katraj in Pune to Mumbai Airport terminals. Comfortable vehicles like sedan, Ertiga, and Innova ensure smooth highway travel. Professional drivers provide punctual pickup services from homes, hotels, and residential societies across Katraj."
},
{
name: "Katraj to Navi Mumbai Cab",
description: "Katraj to Navi Mumbai cab service offers reliable intercity transportation between Pune’s Katraj area and Navi Mumbai. Comfortable vehicles and experienced drivers ensure safe expressway travel for business trips, tourism visits, and family journeys."
},
{
name: "Ambegaon Pune to Mumbai Cab",
description: "Ambegaon Pune to Mumbai cab service provides dependable transportation between Ambegaon in Pune and Mumbai city. Vehicles are comfortable and suitable for expressway travel with professional drivers ensuring safe journeys."
},
{
name: "Ambegaon Budruk to Mumbai Airport Cab",
description: "Ambegaon Budruk to Mumbai Airport cab service offers convenient airport transfers from Ambegaon Budruk in Pune to Mumbai Airport terminals. Vehicles provide comfortable seating and luggage space suitable for airport travel."
},
{
name: "Dhayari to Mumbai Cab",
description: "Dhayari to Mumbai cab service offers reliable transportation between Dhayari in Pune and Mumbai city. Comfortable vehicles and professional drivers ensure safe expressway journeys."
},
{
name: "Mukund Nagar to Mumbai Cab",
description: "Mukund Nagar to Mumbai cab service provides dependable transportation between Mukund Nagar in Pune and Mumbai city. Vehicles are comfortable and suitable for highway travel with experienced drivers ensuring safe journeys."
},
{
name: "Parvati to Mumbai Cab",
description: "Parvati to Mumbai cab service offers convenient transportation between Pune’s Parvati area and Mumbai city. Comfortable vehicles and professional drivers ensure safe long-distance travel."
},
{
name: "Sinhagad Road to Mumbai Cabs",
description: "Sinhagad Road to Mumbai cab service provides reliable transportation between Pune’s Sinhagad Road area and Mumbai city. Vehicles are suitable for expressway travel with professional drivers ensuring safe journeys."
},
{
name: "Katraj to Mumbai One Way Cab",
description: "Katraj to Mumbai one way cab service offers convenient single-trip transportation between Pune and Mumbai. Comfortable sedan and SUV vehicles ensure safe highway travel."
},
{
name: "Dhayari to Mumbai Taxi Service",
description: "Dhayari to Mumbai taxi service offers dependable intercity transportation for passengers traveling from Dhayari to Mumbai. Vehicles are comfortable and suitable for expressway travel."
},
{
name: "Cab Service in Katraj",
description: "Cab service in Katraj provides reliable transportation for local rides, airport transfers, and outstation journeys. Comfortable vehicles and professional drivers ensure safe travel across Katraj and nearby Pune areas."
},
{
name: "Online Cab Booking in Katraj",
description: "Online cab booking in Katraj allows passengers to easily reserve taxis for local travel, airport transfers, and outstation journeys. Flexible booking options and professional drivers ensure convenient travel experiences."
},
{
name: "Book Safe & Reliable Cabs in Katraj",
description: "Book safe and reliable cabs in Katraj for comfortable transportation across Pune and nearby cities. Well-maintained vehicles and experienced drivers ensure secure travel experiences."
},
{
name: "Innova Crysta on Rent in Katraj Pune",
description: "Innova Crysta on rent in Katraj Pune offers premium SUV rental for travelers seeking spacious and comfortable transportation. Ideal for airport transfers, corporate travel, and family trips."
},
{
name: "Ertiga on Rent in Katraj",
description: "Ertiga on rent in Katraj provides comfortable 7-seater SUV transportation suitable for families and small groups. The vehicle offers spacious seating and smooth highway travel performance."
},
{
name: "Sedan Car on Rent in Katraj",
description: "Sedan car on rent in Katraj offers economical transportation for city rides and outstation trips. Vehicles like Swift Dzire and Etios provide comfortable seating and fuel-efficient highway travel."
},
{
name: "Katraj to Mumbai Airport Cabs",
description: "Katraj to Mumbai Airport cabs service provides dependable airport transportation between Pune’s Katraj area and Mumbai Airport terminals. Vehicles ensure comfortable seating and luggage capacity for airport travel."
},
{
name: "Katraj to Dadar Cabs",
description: "Katraj to Dadar cab service offers reliable transportation between Pune and Mumbai’s Dadar area. Comfortable vehicles and experienced drivers ensure safe expressway travel."
},
{
name: "Cab Service in Pune",
description: "Cab service in Pune offers dependable transportation for city rides, airport transfers, and outstation journeys. Comfortable vehicles and professional drivers ensure safe travel across Pune."
},
{
name: "Pune to Mumbai Airport Cab",
description: "Pune to Mumbai Airport cab service provides reliable airport transportation for travelers heading from Pune to Mumbai Airport terminals. Vehicles ensure comfortable seating and safe expressway travel."
},
{
name: "Pune Mumbai Cab",
description: "Pune Mumbai cab service provides dependable intercity transportation between Pune and Mumbai. Comfortable vehicles and professional drivers ensure safe expressway travel."
},
{
name: "Cab Service in Katraj Pune",
description: "Cab service in Katraj Pune offers reliable transportation for local travel, airport transfers, and outstation journeys. Comfortable vehicles and experienced drivers ensure safe travel."
},
{
name: "Katraj to Mumbai Cab",
description: "Katraj to Mumbai cab service offers convenient transportation between Pune and Mumbai. Comfortable vehicles and professional drivers ensure safe expressway journeys."
},
{
name: "Katraj to Mumbai Taxi",
description: "Katraj to Mumbai taxi service provides dependable intercity transportation between Pune and Mumbai. Vehicles are comfortable and suitable for long-distance travel."
},
{
name: "Katraj to Mumbai Cab Service",
description: "Katraj to Mumbai cab service offers reliable transportation between Pune and Mumbai with professional drivers ensuring safe highway journeys."
},
{
name: "Katraj to Mumbai Taxi Service",
description: "Katraj to Mumbai taxi service provides convenient transportation between Pune and Mumbai. Comfortable vehicles and experienced drivers ensure safe travel."
},
{
name: "Katraj to Mumbai Cab Booking",
description: "Katraj to Mumbai cab booking service allows passengers to easily reserve taxis for intercity travel. Flexible booking options ensure convenient travel planning."
},
{
name: "Cab from Katraj to Mumbai",
description: "Cab from Katraj to Mumbai service offers reliable transportation for passengers traveling between Pune and Mumbai. Comfortable vehicles and professional drivers ensure safe expressway journeys."
}
],

tableData: [
["Katraj to Mumbai Airport Cab Fare","Katraj to Navi Mumbai Cab"],
["Ambegaon Pune to Mumbai Cab","Ambegaon Budruk to Mumbai Airport Cab"],
["Dhayari to Mumbai Cab","Mukund Nagar to Mumbai Cab"],
["Parvati to Mumbai Cab","Sinhagad Road to Mumbai Cabs"],
["Katraj to Mumbai One Way Cab","Dhayari to Mumbai Taxi Service"],
["Cab Service in Katraj","Online Cab Booking in Katraj"],
["Book Safe & Reliable Cabs in Katraj","Innova Crysta on Rent in Katraj Pune"],
["Ertiga on Rent in Katraj","Sedan Car on Rent in Katraj"],
["Katraj to Mumbai Airport Cabs","Katraj to Dadar Cabs"],
["Cab Service in Pune","Pune to Mumbai Airport Cab"],
["Pune Mumbai Cab","Cab Service in Katraj Pune"],
["Katraj to Mumbai Cab","Katraj to Mumbai Taxi"],
["Katraj to Mumbai Cab Service","Katraj to Mumbai Taxi Service"],
["Katraj to Mumbai Cab Booking","Cab from Katraj to Mumbai"]
],





whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who frequently travel from Katraj to Mumbai via the Mumbai Pune Expressway. Their knowledge of highway routes and traffic conditions ensures safe and timely intercity travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Katraj to Mumbai cab bookings. Customers receive clear fare details including toll charges and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Katraj to Mumbai cab service operates 24 hours a day. Whether you need an early morning airport transfer, corporate travel, or late night ride, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans from Katraj to Mumbai."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup in Katraj",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, and residential areas across Katraj and nearby areas like Dhankawadi, Ambegaon, Bibwewadi, and Sinhgad Road."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Katraj to Mumbai cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Katraj to Mumbai cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Katraj to Mumbai with professional drivers and comfortable vehicles." },
  { question: "Is Katraj to Mumbai cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Katraj to Mumbai travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Katraj to Mumbai?", answer: "Yes, we provide both one-way and round-trip cab services between Katraj and Mumbai." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, offices, and residential areas across Katraj." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Katraj to Mumbai cab services online or through phone booking." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and holiday travel periods." },
  { question: "Do you provide airport drop service in Mumbai?", answer: "Yes, Velocity Cabs provides drop services to Mumbai Airport and other major locations across Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Jadhav",
    feedback:
      "Travel from Katraj to Mumbai was very smooth and comfortable. The cab was on time, the seating was spacious, and the ride felt safe throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Rutuja Patil",
    feedback:
      "Everything was well managed for the Katraj to Mumbai journey. The vehicle was clean, the driver was polite, and the trip was completed without any hassle.",
    rating: 5
  }
];





































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Katraj to Mumbai Cab Service | Velocity Cabs",
  "description": "Velocity Cabs provides reliable Katraj to Mumbai cab service with affordable fares and professional drivers. Book one way and round trip taxis including Ertiga, Innova, and Sedan cabs for airport transfers, Navi Mumbai, Dadar, Ambegaon, Dhayari, Mukund Nagar, Parvati, Sinhagad Road, and other destinations. Enjoy safe, comfortable, and punctual rides with easy online booking from Katraj to Mumbai.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};



  return (
    <div>
      

<Helmet>
  <title>Katraj to Mumbai Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Katraj to Mumbai cab with Velocity Cabs. Affordable one way, round trip & airport drop taxis including Ertiga, Innova & Sedan cabs for Navi Mumbai, Dadar, Ambegaon, Dhayari, Mukund Nagar & Parvati." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/25.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Katrajtomumbaicab;